import { SelectGroup, SelectItem, SelectLabel } from "@/components/ui/select";
import { useFilters } from "@/context/FilterContext";

const AUTRES = "Autres logements";
export const IMMEUBLE = "immeuble:";

export const grouperParImmeuble = (logements, immeubles) => {
  const groupes = {};
  logements.forEach((l) => { (groupes[immeubles[l] || AUTRES] ||= []).push(l); });
  return Object.keys(groupes).sort((a, b) => (a === AUTRES) - (b === AUTRES) || a.localeCompare(b, "fr")).map((g) => [g, groupes[g]]);
};

export const LogementItems = ({ logements, testPrefix, avecImmeuble }) => {
  const { options } = useFilters();
  const immeubles = options.immeubles || {};
  const item = (l) => <SelectItem key={l} value={l} data-testid={testPrefix ? `${testPrefix}-${l}` : undefined}>{l}</SelectItem>;
  if (!logements.some((l) => immeubles[l])) return logements.map(item);
  return grouperParImmeuble(logements, immeubles).map(([g, ls]) => (
    <SelectGroup key={g} data-testid={`groupe-immeuble-${g}`}>
      <SelectLabel className="text-[10px] font-mono uppercase tracking-wider text-emerald-700">{g}</SelectLabel>
      {avecImmeuble && g !== AUTRES && <SelectItem value={`${IMMEUBLE}${g}`} data-testid={`immeuble-entier-${g}`}>Immeuble entier — {g}</SelectItem>}
      {ls.map(item)}
    </SelectGroup>
  ));
};
